export const BUDGET_IMPORT = 'f-budget-import';
export const BUDGET_TARGETS_IMPORT = 'f-budget-targets-import';
export const SCHEDULE_IMPORT = 'f-schedule-import';
export const BUDGET_METRICS_IMPORT = 'f-budget-metrics-import';
export const SCHEDULE_IMPORTS = [BUDGET_IMPORT, BUDGET_TARGETS_IMPORT, SCHEDULE_IMPORT, BUDGET_METRICS_IMPORT];
